import React from 'react';

import { useCXI } from 'modules/cxi/useCXI';

import { MatchActionEvaluate } from './MatchActionEvaluate';
import { MatchActionFeedback } from './MatchActionFeedback';
import { MatchActionMentoring } from './MatchActionMentoring';
import { MatchActionReevaluate } from './MatchActionReevaluate';
import { MatchActionSpeedDating } from './MatchActionSpeedDating';
import { MatchActionOptions } from './MatchActionOptions';

import * as Styled from './StyledMatchAction';

const MatchActionCurrent = ({ match }) => {
    const { vars } = useCXI();
    const { cxi, isMentoring, mentoring } = vars;

    if (cxi.currentStage > 2) {
        if (
            match.mentoring !== 'none' &&
            ['held'].includes(match.speedDating) &&
            (!isMentoring || (isMentoring && mentoring.matchid === match.matchid))
        ) {
            return <MatchActionMentoring match={match} />;
        }
    }

    if (cxi.currentStage > 1 && match?.evaluated) {
        if (['requested', 'held'].includes(match.speedDating)) {
            return <MatchActionFeedback match={match} />;
        }
        return <MatchActionSpeedDating match={match} />;
    }

    return match?.isCxi && !match?.evaluation?.startupFeedback ? (
        <MatchActionEvaluate match={match} />
    ) : (
        <MatchActionReevaluate match={match} />
    );
};

export const MatchAction = ({ match }) => (
    <Styled.MatchActions>
        <MatchActionCurrent match={match} />

        <MatchActionOptions match={match} />
    </Styled.MatchActions>
);
